import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import '../styles/CambiaPassword.css';

/**
 * PasswordDimenticata
 * L'utente indica il proprio indirizzo e riceve un link di recupero.
 *
 * La schermata di conferma NON dice se l'indirizzo era registrato:
 * rivelarlo qui vanificherebbe la stessa cautela tenuta lato backend.
 */
const PasswordDimenticata = () => {
    const [indirizzo, setIndirizzo] = useState('');
    const [inviato, setInviato] = useState(false);
    const [errore, setErrore] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrore('');
        setLoading(true);
        try {
            await authAPI.passwordDimenticata({ email: indirizzo.trim() });
            setInviato(true);
        } catch (err) {
            setErrore(err.message || 'Non è stato possibile completare la richiesta.');
        } finally {
            setLoading(false);
        }
    };

    if (inviato) {
        return (
            <div className="cp-container">
                <div className="cp-card">
                    <div className="cp-header">
                        <div className="cp-logo">R</div>
                        <h1 className="cp-titolo">Controlla la posta</h1>
                        <p className="cp-sottotitolo">
                            Se l'indirizzo è associato a un account, fra poco arriverà un
                            messaggio con il collegamento per scegliere una nuova password.
                            Vale 30 minuti.
                        </p>
                    </div>
                    <p className="cp-sottotitolo" style={{ marginBottom: 18 }}>
                        Non lo trovi? Guarda anche nella posta indesiderata.
                    </p>
                    <button type="button" className="cp-btn" onClick={() => navigate('/login')}>
                        Torna all'accesso
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="cp-container">
            <div className="cp-card">
                <div className="cp-header">
                    <div className="cp-logo">R</div>
                    <h1 className="cp-titolo">Password dimenticata</h1>
                    <p className="cp-sottotitolo">
                        Indica l'indirizzo email del tuo account: ti manderemo un
                        collegamento per sceglierne una nuova.
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="cp-form">
                    {errore && <div className="cp-errore">{errore}</div>}

                    <div className="cp-group">
                        <label htmlFor="indirizzo">Indirizzo email</label>
                        <div className="cp-input-wrap">
                            <input
                                type="email"
                                id="indirizzo"
                                value={indirizzo}
                                onChange={(e) => setIndirizzo(e.target.value)}
                                placeholder="nome@esempio.it"
                                autoComplete="email"
                                required
                                disabled={loading}
                                style={{ paddingRight: 13 }}
                            />
                        </div>
                    </div>

                    <button type="submit" className="cp-btn" disabled={loading}>
                        {loading ? 'Invio…' : 'Invia il collegamento'}
                    </button>
                </form>

                <div className="cp-piede">
                    <span>Ti è tornata in mente?</span>
                    <button type="button" className="cp-esci" onClick={() => navigate('/login')} disabled={loading}>
                        Torna all'accesso
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PasswordDimenticata;
